import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useLayoutAreaStyles = makeStyles(() => {
  return createStyles({
    area: {
      backgroundColor: '#fff',
      position: 'relative',
    },
    areaPlus: {
      position: 'relative',
      background: '#000',
    },
    containerArea: {
      overflow: 'hidden',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr 1fr',
      gridAutoFlow: 'row',
      gridTemplateAreas: `". ."
          ". ."`,
      height: '8px',
      width: '8px',
      backgroundColor: '#fff',
      gap: '1px',
    },
  });
});

export default useLayoutAreaStyles;
